import React from 'react'
import './pendingpayment.css'
import PendingPaymentTable from '../../components/pending payments/PendingPaymentTable'
const PendingPaymentMain = () => {
  return (
    <div>
      < PendingPaymentTable/>
    </div>
  )
}

export default PendingPaymentMain
